import { useId } from "react";

/** The arena's hexagonal seal: distinct from round gold and faceted diamonds.
 * Self-contained SVG paints also work on the startup screen before menu CSS loads.
 * No filters, animated layers or external assets; 18px is the smallest target.
 */
export function XworenGlyph({ className = "" }: { className?: string }) {
  const id = `xworen-${useId().replace(/:/g, "")}`;
  return <svg className={`xworen-glyph${className ? ` ${className}` : ""}`} data-emblem="arena-seal" viewBox="0 0 32 32" aria-hidden="true" focusable="false">
    <defs>
      <linearGradient id={`${id}-metal`} x1="4" y1="3" x2="26" y2="30" gradientUnits="userSpaceOnUse">
        <stop stopColor="#fff0b9" /><stop offset=".34" stopColor="#d4b46c" /><stop offset=".67" stopColor="#796043" /><stop offset="1" stopColor="#e6c77f" />
      </linearGradient>
      <linearGradient id={`${id}-energy`} x1="23" y1="8" x2="9" y2="24" gradientUnits="userSpaceOnUse">
        <stop stopColor="#d5fff0" /><stop offset=".4" stopColor="#80e0ce" /><stop offset="1" stopColor="#329b9c" />
      </linearGradient>
    </defs>
    <path d="M16 1.2 29 8.6v14.8L16 30.8 3 23.4V8.6Z" fill="#07151d" />
    <path d="M16 1.8 28.4 8.9v14.2L16 30.2 3.6 23.1V8.9Z" fill={`url(#${id}-metal)`} />
    <path d="m16 4.2 10.3 5.9v11.8L16 27.8 5.7 21.9V10.1Z" fill="#112c32" />
    <path d="m16 5.7 9 5.1V21l-9 5.3L7 21V10.8Z" fill="#0a1c25" />
    <path d="M6.2 10.4 16 4.8l9.8 5.6M4.1 9.2 16 2.4l11.9 6.8" fill="none" stroke="#fff4c7" strokeWidth=".7" opacity=".65" />
    <path d="m9 9 4.8 1.2L23 23l-4.8-1.2Z" fill={`url(#${id}-metal)`} />
    <path d="m23 9-4.8 1.2L9 23l4.8-1.2Z" fill={`url(#${id}-energy)`} />
    <path d="m16 13.7 2 2.3-2 2.3-2-2.3Z" fill="#e3ffef" />
    <path d="M16 3.3v2M16 26.7v2" stroke="#8fe1c9" strokeWidth="1.2" />
  </svg>;
}
